module.exports = __webpack_public_path__ + "img/bs_logo.588bff05.svg";